import { render, staticRenderFns } from "./currencyExchangeList.vue?vue&type=template&id=3b44880a&scoped=true"
import script from "./currencyExchangeList.vue?vue&type=script&lang=js"
export * from "./currencyExchangeList.vue?vue&type=script&lang=js"
import style0 from "./currencyExchangeList.vue?vue&type=style&index=0&id=3b44880a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b44880a",
  null
  
)

export default component.exports